import { StrictMode, useCallback, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import ContentGrid from '../components/content-grid/content-grid';
import LoadMoreButton from '../components/loadMoreButton/load-more-button';
import NewsAndMediaFilters from '../components/news-and-media-filters/news-and-media-filters';
import NewsAndMediaMediaFilters from '../components/news-and-media-media-filters/news-and-media-media-filters';
import NotificationBar from '../components/notification-bar/notification-bar';
import context from '../context/context';
import useExtractID from '../services/useExtractID';
import UseExtractTax from '../services/useExtractTax';
import useWordPressData from '../services/useWordPressData';

const NewsAndEvents = () => {
	const className = 'news-and-events';
	const [contentGlobal, setContentGlobal] = useState([]);
	const [additionalGlobal, setAdditionalGlobal] = useState([]);
	const [filtersGlobal, setFiltersGlobal] = useState([]);
	const [triggerRefresh, setTriggerRefresh] = useState(false);
	const [noResults, setNoResults] = useState(false);
	const [noResultsTranslation, setNoResultsTranslation] = useState('');
	const ID = useExtractID();
	const Tax = UseExtractTax();
	const filter_data = useWordPressData('get_news_and_events_filters', ID);

	const fetchData = useCallback(async () => {
		try {
			const response = await fetch(ajax_params.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
				body: new URLSearchParams({
					action: 'get_news_and_events',
					ID: ID ?? 0,
					tax: Tax ?? '',
					filters: JSON.stringify(filtersGlobal ?? []),
					page: additionalGlobal?.page ?? 1,
				}),
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const data = await response.json();

			if (data.success) {
				setContentGlobal((prevContent) => [
					...prevContent,
					...data.data.content,
				]);
				setAdditionalGlobal(data.data.additional_data);
				if (data.data.additional_data.no_results === true) {
					setNoResults(true);
					setNoResultsTranslation(
						data.data.additional_data.no_results_translation
					);
				}
			} else {
				console.error('Data fetch was not successful:', data.message);
			}
		} catch (error) {
			console.error('Fetching data failed:', error);
		}
	}, [filtersGlobal, additionalGlobal, ID]);

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		if (triggerRefresh) {
			fetchData();
			setTriggerRefresh(false);
			setNoResults(false);
		}
	}, [triggerRefresh]);

	return (
		<StrictMode>
			<context.Provider
				value={{
					contentGlobal,
					setContentGlobal,
					additionalGlobal,
					setAdditionalGlobal,
					filtersGlobal,
					setFiltersGlobal,
					triggerRefresh,
					setTriggerRefresh,
				}}
			>
				<NewsAndMediaMediaFilters data={filter_data} />
				<div className={`${className}__master-grid`}>
					<NewsAndMediaFilters
						data={filter_data}
					></NewsAndMediaFilters>
					<ContentGrid className={className} data={contentGlobal} />
				</div>
				<div className={`${className}__master-grid`}>
					<span></span>
					<LoadMoreButton
						className={className}
						data={contentGlobal}
					></LoadMoreButton>
				</div>
			</context.Provider>
			{noResults && (
				<>
					<NotificationBar
						type="warning"
						redirect_message={noResultsTranslation}
					/>
				</>
			)}
		</StrictMode>
	);
};

export default NewsAndEvents;

const rootElement = document.getElementById('news-and-media--react');

if (rootElement) {
	const root = createRoot(rootElement);
	root.render(<NewsAndEvents />);
}
